import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@bt/shared';
import {NgSelectizeModule} from 'ng-selectize';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SessionsComponent } from './sessions.component';

@NgModule({
    imports: [
      CommonModule,
      FormsModule,
      SharedModule,
      NgSelectizeModule,
      FontAwesomeModule
    ],
    declarations: [
        SessionsComponent,
    ],
  })
  export class SessionsModule { }


// WEBPACK FOOTER //
// ./src/app/sessions/sessions.module.ts